// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { useSplitPermissions } from '@Hooks/useSplitPermissions';
import { useCurrentUser } from '@Queries/userQueries';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { useParams } from 'react-router-dom';
import { AlertOutput, PermissionsEnum } from 'thehive-sdk';
import { AttachmentAlertsList } from './AttachmentAlertsList';
import { THPreview, usePreview } from '@Molecules/THPreview';
import { useListAllFields } from '@Queries/describeQueries';
import usePageTitle from '@Hooks/usePageTitle';
import useOneQuery from '@Hooks/useOneQuery';
import { computeGetSelector } from '@Organisms/Alert/selector';
import client from '@Client';
import { useLocalMessage } from '@Helpers/locale';

const AlertAttachmentListPage = () => {
    const i = useLocalMessage();
    const { alertId } = useParams<{ alertId: string }>();

    const { data: currentUser } = useCurrentUser();
    const { permissions = [] } = currentUser || {};
    const hasPermissions = useSplitPermissions(permissions, [PermissionsEnum.MANAGE_ALERT_UPDATE]);

    const { data: alertData } = useOneQuery<AlertOutput>({
        selector: computeGetSelector({ alertId }),
        controller: client.CaseController,
        manual: true,
        fetchOnStart: false,
    });

    const { data: describe } = useListAllFields();
    const previewManager = usePreview();

    // usePageTitle(`${i('page-title.alerts.attachments')} ${alertData?.title}`);
    usePageTitle(i('page-title.alerts.attachments', { title: alertData?.title || '' }));

    return (
        <>
            {/* Preview */}
            {previewManager.content && previewManager.type && (
                <THPreview
                    src={previewManager.content}
                    onClick={previewManager.togglePreview}
                    type={previewManager.type}
                    extension={previewManager.extension}
                />
            )}
            {/* List */}
            <AttachmentAlertsList
                describe={describe}
                previewManager={previewManager}
                parentId={alertId}
                hasPermissions={hasPermissions.updateAlert}
            />
        </>
    );
};

export const Route: RouteType = {
    menu: {
        label: 'alert.layout.nav-bar.attachments',
        icon: <ICONS.FileSearchOutlined />,
    },
    path: RouteBuilder.compute('alerts.attachments'),
    content: <AlertAttachmentListPage />,
    space: ['user'],
    breadcrumb: { label: 'breadcrumb.alert.attachments' },
};
